module.exports = __webpack_public_path__ + "tables1.png?ecc938c71d1e9a783482ac399893730f";